import { Injectable } from '@angular/core';
import { BaseLocationServiceInterface } from './base-location.service';

@Injectable({
  providedIn: 'root',
})
export class BaseLocationBrowserService implements BaseLocationServiceInterface {

  public readonly origin: string;
  public readonly host: string;
  public readonly hostname: string;
  public readonly port: string;
  public readonly protocol: string;

  public constructor() {
        this.host = window.location.host;
        this.hostname = window.location.hostname;
        this.port = window.location.port;
        this.protocol = window.location.protocol;
        this.origin = window.location.origin;
  }

}
